import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { NbSidebarState } from '@nebular/theme';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {

  private sidebarState$ = new BehaviorSubject<NbSidebarState>(null);

  private currentUrl: string;
  private previousUrl: string;

  constructor(private router: Router) {
    this.currentUrl = this.router.url.slice(1, 5);
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url.slice(1, 5);
      };
    });
  }

  setSidebarState(state: NbSidebarState, checkUrls = true) {
    if (!(this.currentUrl === 'home' && this.previousUrl === 'home' && checkUrls &&
      state === 'expanded' && this.sidebarState$.getValue() === 'compacted')) {
      this.sidebarState$.next(state);
    }
  }

  getSidebarState(): Observable<NbSidebarState> {
    return this.sidebarState$.asObservable();
  }

  changeRoute(route: string): void {
    this.router.navigate([route]);
  }

}
